// Mock data for Better Fence & Deck clone

export const COMPANY = {
  name: 'Better Fence & Deck',
  tagline: 'Your Fence. Done Right. Done Better.',
  phone: '318-344-7190',
  phoneRaw: '3183447190',
  email: 'Betterfenceanddeckla@gmail.com',
  city: 'Shreveport, LA',
  region: 'ArkLaTex',
  address: 'Shreveport, Louisiana',
  hours: 'Mon–Sat 7:00 AM – 7:00 PM',
};

export const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '#services' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'About', href: '#about' },
  { label: 'Book', href: '#book' },
  { label: 'Blog', href: '/blog' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contact', href: '#quote' },
];

export const HERO_STATS = [
  { value: '15+', label: 'Years Building' },
  { value: '2,400+', label: 'Fences Installed' },
  { value: '4.9★', label: 'Customer Rating' },
  { value: '100%', label: 'Guaranteed' },
];

export const SERVICES = [
  {
    id: 'wood',
    title: 'Wood Fencing',
    blurb: 'Classic cedar and pine privacy fences, picket, and custom wood designs built to last decades.',
    image: '/gallery/06-cedar-with-trailer.jpg',
    features: ['Cedar & Pine', 'Privacy & Picket', 'Custom Gates'],
    from: '$18/ft',
  },
  {
    id: 'vinyl',
    title: 'Vinyl Fencing',
    blurb: 'Low-maintenance vinyl privacy and picket fences that stay beautiful year after year.',
    image: '/gallery/19-vinyl-picket.jpg',
    features: ['Never Paint Again', 'UV Resistant', 'Lifetime Warranty'],
    from: '$28/ft',
  },
  {
    id: 'chainlink',
    title: 'Chain-Link Fencing',
    blurb: 'Durable galvanized and vinyl-coated chain-link for residential, commercial, and industrial.',
    image: '/gallery/09-chainlink-pond.jpg',
    features: ['Galvanized Steel', 'Vinyl Coated', 'Commercial Grade'],
    from: '$12/ft',
  },
  {
    id: 'iron',
    title: 'Ornamental Iron',
    blurb: 'Elegant powder-coated ornamental iron and aluminum fencing for curb appeal and security.',
    image: '/gallery/03-iron-yard.jpg',
    features: ['Powder-Coated', 'Custom Designs', 'Rust-Proof'],
    from: '$45/ft',
  },
  {
    id: 'deck',
    title: 'Deck Building',
    blurb: 'Custom composite and wood decks designed to extend your living space and boost property value.',
    image: '/gallery/29-deck-yellow-porch.jpg',
    features: ['Covered Porches', 'Custom Pergolas', 'Slat Screens'],
    from: '$32/sqft',
  },
  {
    id: 'ranch',
    title: 'Farm & Ranch',
    blurb: 'Board, split-rail, and pipe fencing for agricultural and rural properties of any size.',
    image: '/gallery/11-wood-field.jpg',
    features: ['Miles of Fence', 'Split Rail', 'Pipe & Cable'],
    from: 'Custom',
  },
];

export const PROCESS_STEPS = [
  { n: '01', title: 'Free Consultation', desc: 'Call or fill the form. A real person answers — usually within an hour.' },
  { n: '02', title: 'On-Site Estimate', desc: 'We come to you, measure, and hand you a detailed written quote. No pressure.' },
  { n: '03', title: 'Expert Installation', desc: 'Our insured crew builds it right the first time — clean site, clear timeline.' },
  { n: '04', title: 'Walk-Through & Warranty', desc: 'We walk the property with you and stand behind every post we set.' },
];

export const GALLERY = [
  { id: 1, cat: 'Wood', title: 'Cedar Privacy at Dusk', location: 'Shreveport, LA', image: '/gallery/01-hero-dusk-pool.jpg' },
  { id: 2, cat: 'Wood', title: 'Poolside Cedar Fence', location: 'Bossier City, LA', image: '/gallery/02-pool-sunset.jpg' },
  { id: 3, cat: 'Iron', title: 'Ornamental Iron Yard Line', location: 'Benton, LA', image: '/gallery/03-iron-yard.jpg' },
  { id: 6, cat: 'Wood', title: 'New Cedar Privacy Line', location: 'Minden, LA', image: '/gallery/06-cedar-with-trailer.jpg' },
  { id: 7, cat: 'Wood', title: 'Tall Cedar Fence', location: 'Bossier City, LA', image: '/gallery/07-cedar-tall.jpg' },
  { id: 8, cat: 'Wood', title: 'Fresh Cedar Install', location: 'Natchitoches, LA', image: '/gallery/08-cedar-fresh.jpg' },
  { id: 9, cat: 'Chain-Link', title: 'Lakeside Chain-Link Line', location: 'Mansfield, LA', image: '/gallery/09-chainlink-pond.jpg' },
  { id: 10, cat: 'Wood', title: 'Wood Fence at Brick Home', location: 'Shreveport, LA', image: '/gallery/10-wood-brick-house.jpg' },
  { id: 11, cat: 'Wood', title: 'Long Wood Fence in Field', location: 'Longview, TX', image: '/gallery/11-wood-field.jpg' },
  { id: 13, cat: 'Wood', title: 'Wood with Iron Gate Posts', location: 'Haughton, LA', image: '/gallery/13-wood-iron-gate-inprogress.jpg' },
  { id: 14, cat: 'Wood', title: 'Sunset Wood Fence', location: 'Stonewall, LA', image: '/gallery/14-wood-dusk-branches.jpg' },
  { id: 15, cat: 'Wood', title: 'After the Storm — Rebuild', location: 'Keithville, LA', image: '/gallery/15-wood-fallen-tree.jpg' },
  { id: 16, cat: 'Chain-Link', title: 'Chain-Link at Backyard', location: 'Shreveport, LA', image: '/gallery/16-chainlink-kiddie-pool.jpg' },
  { id: 17, cat: 'Chain-Link', title: 'Chain-Link at Brick Estate', location: 'Bossier City, LA', image: '/gallery/17-chainlink-brick-estate.jpg' },
  { id: 18, cat: 'Wood', title: 'Small-Yard Privacy Fence', location: 'Greenwood, LA', image: '/gallery/18-wood-small-fresh.jpg' },
  { id: 19, cat: 'Vinyl', title: 'Vinyl Picket with Scalloped Top', location: 'Shreveport, LA', image: '/gallery/19-vinyl-picket.jpg' },
  { id: 20, cat: 'Wood', title: 'Pine Privacy at Brick Home', location: 'Shreveport, LA', image: '/gallery/20-wood-pine-privacy.jpg' },
  { id: 21, cat: 'Chain-Link', title: 'Backyard Chain-Link', location: 'Shreveport, LA', image: '/gallery/16-chainlink-kiddie-pool.jpg' },
  { id: 22, cat: 'Deck', title: 'Custom Slat Deck with Pergola', location: 'Shreveport, LA', image: '/gallery/22-deck-slat-pergola.jpg' },
  { id: 23, cat: 'Deck', title: 'Yellow-House Custom Deck', location: 'Shreveport, LA', image: '/gallery/23-deck-yellow-house.jpg' },
  { id: 24, cat: 'Deck', title: 'Cedar Boardwalk', location: 'Natchitoches, LA', image: '/gallery/24-deck-boardwalk-clouds.jpg' },
  { id: 25, cat: 'Deck', title: 'Slat-Wall Deck Detail', location: 'Shreveport, LA', image: '/gallery/25-deck-slat-shadow.jpg' },
  { id: 26, cat: 'Deck', title: 'Custom Pergola & Slats', location: 'Shreveport, LA', image: '/gallery/26-deck-slat-pergola-2.jpg' },
  { id: 27, cat: 'Deck', title: 'Deck Framing', location: 'Bossier City, LA', image: '/gallery/27-deck-yellow-framing.jpg' },
  { id: 28, cat: 'Deck', title: 'Custom Backyard Deck', location: 'Bossier City, LA', image: '/gallery/28-deck-yellow-custom.jpg' },
  { id: 29, cat: 'Deck', title: 'Covered Porch Deck', location: 'Bossier City, LA', image: '/gallery/29-deck-yellow-porch.jpg' },
  { id: 30, cat: 'Deck', title: 'Freshly Stained Deck', location: 'Haughton, LA', image: '/gallery/30-deck-stained-worker.jpg' },
  { id: 31, cat: 'Deck', title: 'Deck Structural Build', location: 'Bossier City, LA', image: '/gallery/31-deck-yellow-frame.jpg' },
  { id: 32, cat: 'Deck', title: 'Cedar Deck by the Tree', location: 'Minden, LA', image: '/gallery/32-deck-cedar-tree.jpg' },
  { id: 33, cat: 'Deck', title: 'Cedar Deck Planks', location: 'Longview, TX', image: '/gallery/33-deck-cedar-planks.jpg' },
  { id: 34, cat: 'Deck', title: 'Sunset Dock', location: 'Natchitoches, LA', image: '/gallery/34-deck-dock-sunset.jpg' },
  { id: 35, cat: 'Wood', title: 'Twilight Fence Silhouette', location: 'Benton, LA', image: '/gallery/35-sunset-atmospheric.jpg' },
];

export const GALLERY_CATS = ['All', 'Wood', 'Vinyl', 'Iron', 'Chain-Link', 'Deck'];

export const TESTIMONIALS = [
  { name: 'Marcus Trahan', city: 'Shreveport, LA', rating: 5, text: 'From the quote to the last picket, these guys were dialed in. My cedar fence looks like a piece of furniture. Neighbors keep asking who did it.' },
  { name: 'Kayla R.', city: 'Bossier City, LA', rating: 5, text: 'Called on a Monday, they were out Tuesday, done by Friday. Tight, straight, and a fair price. Absolutely recommend.' },
  { name: 'Dr. Alan Patel', city: 'Benton, LA', rating: 5, text: 'Our ornamental iron entry gate is gorgeous. The crew treated our property like their own — clean, quiet, professional.' },
  { name: 'The Boudreaux Family', city: 'Haughton, LA', rating: 5, text: 'They built us a two-tier composite deck with a pergola. It changed how we use our backyard. Worth every penny.' },
  { name: 'Renee Colston', city: 'Minden, LA', rating: 5, text: 'Real people answered the phone. Real quote showed up. Real fence went in. Zero drama. I will use them again.' },
];

export const SERVICE_AREAS = [
  'Shreveport', 'Bossier City', 'Haughton', 'Benton',
  'Mansfield', 'Longview, TX', 'Marshall, TX', 'Waskom, TX',
  'Carthage, TX', 'Stonewall', 'Keithville', 'Greenwood',
];

export const WHY_US = [
  { icon: 'Trophy', title: 'We Out-Perform', desc: 'Whatever they can do, we do better — higher-grade materials, tighter craft, prouder crew.' },
  { icon: 'ShieldCheck', title: 'Fully Insured', desc: 'Full liability coverage from day one. Zero risk on your property, ever.' },
  { icon: 'Zap', title: 'Fast Turnaround', desc: 'Most residential jobs wrap on schedule with clear timelines up front.' },
  { icon: 'FileCheck', title: 'Free Estimates', desc: 'Detailed, on-site written quotes. No pressure. No hidden fees. Ever.' },
  { icon: 'BadgeCheck', title: 'Quality Guaranteed', desc: 'If it isn\'t right, we make it right. That\'s our word on every job.' },
  { icon: 'PhoneCall', title: 'Real Humans', desc: 'Call 318-344-7190 — no voicemail maze, no call center. Just answers.' },
];

export const FAQS = [
  { q: 'How long does a typical fence installation take?', a: 'Most residential wood or vinyl fences (100–250 ft) are completed in 2–4 days once materials arrive. Ornamental iron and custom decks may take 5–10 days. You\'ll get a clear timeline before we start.' },
  { q: 'Do you offer free estimates?', a: 'Yes. Every estimate is free, on-site, and no-obligation. We measure, discuss materials and layout, and hand you a written quote.' },
  { q: 'Are you insured?', a: 'Yes. Better Fence & Deck carries general liability insurance. Certificate available on request.' },
  { q: 'What materials do you use?', o: 'We source premium cedar, pressure-treated pine, commercial-grade vinyl, powder-coated iron/aluminum, galvanized chain-link, and Trex/TimberTech composite decking.' , a: 'We source premium cedar, pressure-treated pine, commercial-grade vinyl, powder-coated iron/aluminum, galvanized chain-link, and Trex/TimberTech composite decking.'},
  { q: 'Do you handle permits and HOA approvals?', a: 'We assist with local permits and provide the drawings/specs your HOA typically needs. You submit; we build once approved.' },
  { q: 'Do you offer financing?', a: 'Yes — we partner with financing providers for projects over $2,500. Ask us for current rates when we quote.' },
  { q: 'Do you warranty your work?', a: 'Yes. Labor is warrantied for 2 years; materials carry manufacturer warranties (some vinyl and composite up to lifetime).' },
];

export const FENCE_TYPES = ['Wood', 'Vinyl', 'Chain-Link', 'Ornamental Iron', 'Deck', 'Farm/Ranch', 'Not Sure Yet'];
export const TIMELINES = ['ASAP', 'Within 2 weeks', 'Within 1–2 months', 'Just planning'];
